import React, { ReactNode, memo } from 'react'
import DownloadIcon from 'transfix-icons/build/DownloadIcon'
import { LogoIcon } from 'transfix-ui/components/LogoIcon'
import { Box, makeStyles } from 'transfix-ui/core'
import {
  IActivity,
  isActivityShipmentCreated,
  isActivityShipmentImported,
} from 'apps/fleet-planner/types'
import { Avatar } from 'transfix-ui'

interface IActivityIconProps {
  activity: IActivity
}

/**
 * Logic determines which type of icon to show, depending on activity type
 */
const getIconType = (activity: IActivity): ReactNode => {
  const { actorFullName = '' } = activity || {}
  let defaultNode = <Avatar tooltipClassName='tc' name={actorFullName} />

  const isCreated = isActivityShipmentCreated(activity) && !activity?.actorFullName
  const isImported = isActivityShipmentImported(activity)
  const hasDownloadIcon = isCreated || isImported

  if (hasDownloadIcon) {
    defaultNode = <DownloadIcon size='xlarge' color='coolGray8' className='ml1' />
  } else if (actorFullName === 'Transfix') {
    defaultNode = <LogoIcon />
  }

  return defaultNode
}

const useActivityIconStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',

    // limits size of <LogoIcon />
    '& svg': {
      maxWidth: 32,
      maxHeight: 21,
    },
  },
})

/**
 * Icon used in each <ActivityRow /> to show the author's initials or a logo
 */
export const ActivityIcon = memo<IActivityIconProps>(({ activity }) => {
  const classes = useActivityIconStyles()
  const Icon = getIconType(activity)
  return <Box className={classes.root}>{Icon}</Box>
})
